import { create } from 'zustand';

import type { PaymentMethod, ProductShortKeyType } from '@/api/payments';

type PaymentDetails = {
  amount: string;
  expenseType?: string;
  month?: string;
  receipt?: string;
};

type InitialState = {
  //   property: AddPropertyType;
  //   bankDetails: AddBankDetail;
  propertyId: string;
  bankId: string;
  paymentFor: string;
  productKey: ProductShortKeyType;
  paymentDetails: PaymentDetails;
  paymentId: string;
  paymentMethod: PaymentMethod;
  beneficiaryName: string;
  activeBreadCrumb: string;
};

const initialValues: InitialState = {
  //   bankDetails: {
  //     accountNumber: "",
  //     confirmAccount: "",
  //     ifsc: "",
  //     name: "",
  //     nickName: "",
  //   },
  //   property: {
  //     address: "",
  //     city: "",
  //     pincode: "",
  //     state: "",
  //     propertySaveAs: "",
  //   },
  bankId: '',
  propertyId: '',
  paymentFor: '',
  productKey: 'RP',
  paymentDetails: {
    amount: '',
    month: '',
    receipt: '',
    expenseType: '',
  },
  paymentId: '',
  paymentMethod: 'CREDIT_CARD',
  beneficiaryName: '',
  activeBreadCrumb: '',
};

export type BillUpdateMethods = {
  updatePaymentFor: (type: string) => void;
  //   updatePropertyDetails: () => void;
  //   updateBankDetails: () => void;
  //   updateAmount: () => void;
  //   updatePaymentMethod: () => void;
  updateBankId: (id: string) => void;
  updatePropertyId: (id: string) => void;
  updateProductKey: (key: ProductShortKeyType) => void;
  updatePaymentDetails: (paymentDetails: PaymentDetails) => void;
  updatePaymentId: (paymentId: string) => void;
  updatePaymentMethod: (method: PaymentMethod) => void;
  updateBeneficiaryName: (name: string) => void;
  updateActiveBreadCrumb: (activeVar: string) => void;
  resetState: () => void;
};

export const useRentPaymentStore = create<InitialState & BillUpdateMethods>(
  (set) => ({
    ...initialValues,
    // updateAmount: () =>
    //   set((state) => ({
    //     ...state,
    //   })),
    // updateBankDetails: () =>
    //   set((state) => ({
    //     ...state,
    //   })),
    // updatePaymentMethod: () =>
    //   set((state) => ({
    //     ...state,
    //   })),
    updatePaymentFor: (type: string) =>
      set((state) => ({
        ...state,
        paymentFor: type,
      })),
    updateProductKey: (key: ProductShortKeyType) =>
      set((state) => ({
        ...state,
        productKey: key,
      })),
    // updatePropertyDetails: () =>
    //   set((state) => ({
    //     ...state,
    //     // property: {
    //     //   ...state.property,
    //     // },
    //   })),
    updateBankId: (id: string) =>
      set((state) => ({
        ...state,
        bankId: id,
      })),
    updatePropertyId: (id: string) =>
      set((state) => ({
        ...state,
        propertyId: id,
      })),
    updatePaymentDetails: (paymentDetails) =>
      set((state) => ({
        ...state,
        paymentDetails,
      })),
    updatePaymentId: (paymentId) =>
      set((state) => ({
        ...state,
        paymentId,
      })),
    updatePaymentMethod: (method: PaymentMethod) =>
      set((state) => ({
        ...state,
        paymentMethod: method,
      })),
    updateBeneficiaryName: (name: string) =>
      set((state) => ({
        ...state,
        beneficiaryName: name,
      })),
    updateActiveBreadCrumb: (name: string) =>
      set((state) => ({
        ...state,
        activeBreadCrumb: name,
      })),
    resetState: () => set(initialValues),
  })
);
